<!-- HTML -->
<template>
    <div class="custom-style-header pt10 pb10">
        <div class="custom-style-content flex y-center">
            <div class="flex">
                <div class="header-content-item logo">
                    <img src="~@/assets/images/logo-min.png" alt="">
                </div>
                <template v-if="hallData">
                    <div class="header-hall ml40 flex y-center">
                        <div>
                            <div class="color000 fs16"><strong>{{hallData.hall_name}}</strong></div>
                            <div class="color999">{{hallData.hall_desc}}</div>
                        </div>
                    </div>
                    <div class="flex y-center">
                        <router-link target="_blank" class="ml40" :to="`/preview/${$route.params.meeting_id}?hall_id=${hallData.id}`"><a-button type="primary" class="btn-style">座位预览</a-button></router-link>
                    </div>
                    
                    <div class="flex y-center ml40">
                        <div>是否显示无效座位</div>
                        <a-switch class="ml5" @change="handleSwitchChangeEvent" :checked="isShowInvalidSeat" />
                    </div>
                </template> 
            </div>
           <div class="flex y-center">
            <zoom-widget class="mr20" :scale-number="$store.state.scaleNumber" v-if="hallData"></zoom-widget>
            <!-- <div v-if="meetingInfo" class="header-content-item mr25">
                <div class="header-text">
                    <div class="fs16 fb"><strong>{{ meetingInfo.cn_title }}</strong></div>
                    <div class="color999">
                        <span>地址：{{ meetingInfo.venue_name_cn }}</span>
                        <span class="ml20">时间：{{ meetingInfo.start_time.substr(0,10) }}</span>
                    </div>
                </div>
            </div> -->
            <a-dropdown v-if="routerName!='Searchseat'" class="mr20" placement="bottomCenter">
                <a style="height:32px;" class="flex y-center ant-dropdown-link"
                    @click="e => e.preventDefault()">
                    <span class="avatar-style">
                        <i class="med med-VIP"></i>
                        <a-avatar icon="user"
                        :src="userInfo.Avatar || require('@/assets/images/person-default.png')" />
                    </span>
                    <span style="max-width:100px;" class="ml10 row-1 color666 fs16">{{ userInfo.RealName }}</span>
                    <a-icon class="color333 ml10" type="down" />
                </a>
                <a-menu slot="overlay" style="max-width:100px;">
                    <a-menu-item class="t-c">
                        <a @click="handlelogoutEvent" href="javascript:;">安全退出</a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
           </div>
        </div>
        <slot></slot>
    </div>
</template>

<!-- js脚本 -->
<script>
import { mapState } from 'vuex';
import zoomWidget from '@/components/zoom-widget.vue';
export default {
    props: {},
    components:{zoomWidget},
    data() {
        return {
            hallData: null,
            routerName: '',
        }
    },
    watch: {
        '$route.name': {
            handler() {
                this.hallData = null;
                this.routerName = this.$route.name;
                this.routerName == 'Area' && this.getHallData();
            },
            immediate: true,
        },
    },
    computed:{
        ...mapState(['userInfo','meetingInfo','isShowInvalidSeat']),
    },
    methods: {
        // 切换座位状态
        handleSwitchChangeEvent(e) {
            this.$store.commit('updateState', { isShowInvalidSeat: e });
        },
        // 获取数据
        getHallData() {
            this.$request.post({ url: "getHall" }).then(res => {
                this.hallData = res.data.findItem({ id: this.$route.params.hall_id });
            })
        },
        // 退出登录
        handlelogoutEvent() {
            this.$storage.set('auth', '');
            let committee_login_url = this.$storage.get('committee_login_url');
            let committee_id = this.$storage.get('committee_id');
            window.location.href = committee_login_url+'/site/logout/'+committee_id
        },
    },
    mounted() {
    }
};
</script>

<!-- css样式 -->
<style lang="less" scoped>
.custom-style-header {
    border-bottom: 1px solid #f5f6f9;
    min-height: 60px; //box-shadow: inset 0 -2px 5px rgba(0,0,0,.1);
    background-color: #fff;
}

// 手机端适配
@media (max-width: 767px) {
    .custom-style-header {
        padding: 15px;
       
        .custom-style-content {
            display: block;
            .logo {
                display: none;
            }
        }
        .max-width {
            margin: 15px auto 0 !important;
        }
        .header-content-item {
            margin-right: 0;
        }
    }
}
</style>